import { CreditCard, Loader2, ExternalLink, Settings } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { SettingsLayout } from './SettingsLayout';
import { useAuth } from '@/contexts/AuthContext';

export function BillingSettingsPage() {
  const { user, projects } = useAuth();

  if (!user) {
    return (
      <SettingsLayout>
        <div className="flex items-center justify-center py-8">
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        </div>
      </SettingsLayout>
    );
  }

  return (
    <SettingsLayout>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <CreditCard className="h-5 w-5" />
            Projects & Billing
          </CardTitle>
          <CardDescription>
            Your project memberships and billing access. All billing is managed at the project level.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Alert>
            <AlertDescription>
              Each project has its own subscription and billing settings. Use the links below to access project-specific billing.
            </AlertDescription>
          </Alert>

          {projects && projects.length > 0 ? (
            <div className="space-y-3">
              <p className="text-sm text-muted-foreground">Your projects</p>
              {projects.map((project) => (
                <div key={project.id} className="flex items-center justify-between p-3 border rounded-lg">
                  <div>
                    <h4 className="font-medium">{project.name}</h4>
                    <p className="text-sm text-muted-foreground">Project ID: {project.id}</p>
                  </div>
                  <Button variant="outline" size="sm" asChild>
                    <a href={`/project/${project.id}/settings`} className="flex items-center gap-2">
                      <Settings className="h-4 w-4" />
                      Project Settings
                    </a>
                  </Button>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-6">
              <p className="text-muted-foreground mb-4">You don't have any projects yet.</p>
              <Button asChild>
                <a href="/projects" className="flex items-center gap-2">
                  <ExternalLink className="h-4 w-4" />
                  Create Your First Project
                </a>
              </Button>
            </div>
          )}

          <div className="pt-4 border-t">
            <Button variant="outline" asChild>
              <a href="/projects" className="flex items-center gap-2">
                <ExternalLink className="h-4 w-4" />
                View All Projects
              </a>
            </Button>
          </div>
        </CardContent>
      </Card>
    </SettingsLayout>
  );
}
